const TABLE_PREVIEW_SRC = '/table-preview.png'

const tableFeatures = [
  {
    num: '1',
    title: 'Mapa de mesas em tempo real',
    desc: 'Visualize quais mesas estão livres, ocupadas ou aguardando — com um clique para ver o detalhe.',
  },
  {
    num: '2',
    title: 'QR Code por mesa',
    desc: 'Cada mesa tem um QR code único. O cliente escaneia, entra no cardápio e faz o pedido sozinho.',
  },
  {
    num: '3',
    title: 'Sessões e fechamento de conta',
    desc: 'Abra e feche sessões por mesa. Veja todos os pedidos da sessão e emita o recibo na hora.',
  },
  {
    num: '4',
    title: 'Impressão direta para a cozinha',
    desc: 'Configure salas de impressão — cozinha, bar, balcão — e os pedidos chegam impressos automaticamente.',
  },
]

export default function TablesSection() {
  return (
    <section className="bg-white px-5 py-16 sm:px-8 sm:py-20 lg:px-16 lg:py-24 scroll-mt-24" id="mesas">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-[11px] font-bold uppercase tracking-[2px] text-neutral-400 mb-3">
          Gestão de Mesas
        </div>
        <h2 className="text-[30px] sm:text-[38px] lg:text-[50px] font-black tracking-tight leading-[1.1] mb-4">
          Cada mesa,<br />sob controle.
        </h2>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-8 xl:gap-12 mt-10 lg:mt-16 lg:items-start">
          {/* Preview — first: top on mobile, left on desktop */}
          <div className="flex-1 min-w-0 w-full flex justify-center lg:justify-start">
            <div className="w-full max-w-[640px] sm:max-w-[720px] mx-auto lg:mx-0 lg:max-w-none rounded-2xl overflow-hidden border border-neutral-200 bg-white shadow-[0_28px_80px_rgba(0,0,0,0.08)] ring-1 ring-black/[0.04]">
              <img
                src={TABLE_PREVIEW_SRC}
                alt="Painel Waithere — gestão de mesas com mapa, status livre ocupada reservada e QR code"
                className="w-full h-auto block select-none"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>

          <div className="flex-1 min-w-0 max-w-[520px] lg:max-w-[38%] xl:max-w-[420px] lg:flex-shrink-0">
            <p className="text-base lg:text-[17px] text-neutral-500 leading-[1.7] max-w-[500px] mb-6 lg:mb-8">
              Veja o status de todas as mesas em tempo real, abra sessões, acompanhe pedidos e feche contas sem sair do painel.
            </p>
            <div className="flex flex-col gap-5">
              {tableFeatures.map((feat) => (
                <div key={feat.num} className="flex gap-3.5 items-start">
                  <div className="w-9 h-9 bg-black text-white rounded-full flex items-center justify-center text-sm font-extrabold flex-shrink-0">
                    {feat.num}
                  </div>
                  <div>
                    <h4 className="text-[15px] font-bold mb-1">{feat.title}</h4>
                    <p className="text-sm text-neutral-500 leading-[1.55]">{feat.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
